export default "__VITE_ASSET__DKQglZi___"